import { default_routes } from "./default";
import { admin_routes } from "./admin_routes";
import { affiliate_routes } from "./affiliate_routes";
import { general_routes } from "./general";

const allRoutes = [
  ...default_routes,
  ...admin_routes,
  ...affiliate_routes,
  ...general_routes
];

export const routes = allRoutes;
